export const CLEAR_SALES_BY_ITEMS_REPORT_DATA = "salesByItemsReport/clear"

export const clearSalesByItemsReportData = () => ({
    type: CLEAR_SALES_BY_ITEMS_REPORT_DATA,
})

export const SALES_BY_ITEMS_REPORT_AGENDA_MOUNTED = "salesByItemsReport/mounted"

export const salesByItemsAgendaMounted = () => ({
    type: SALES_BY_ITEMS_REPORT_AGENDA_MOUNTED,
})
